@let canDisplayMobileActions = canDisplayMobileActions$ | async;

<ng-content />

<ng-template #actionsTemplate>
  <ng-content select="[actions]" />
</ng-template>

<div class="profile-block" [class.profile-block-secondary]="type() === 'secondary'">
  <div class="profile-info-block">
    <div class="data">
      <app-profile-data [profile]="profile()" [isLoading]="isLoading()" />

      @if (socialLinks()) {
        <div class="social-proof">
          <app-social-links [links]="socialLinks()" />
        </div>
      }

      @if (!canDisplayMobileActions) {
        <div class="profile-actions actions-desktop">
          <ng-container [ngTemplateOutlet]="actionsTemplate" />
        </div>
      }
    </div>

    <app-profile-avatar [profile]="profile()" [isLoading]="isLoading()" />
  </div>

  @if (canDisplayMobileActions) {
    <div class="profile-actions actions-mobile">
      <ng-container [ngTemplateOutlet]="actionsTemplate" />
    </div>
  }

  <ng-content select="[profileLinks]" />
</div>
